import { __decorate } from "tslib";
import timesync from 'timesync';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';
import { convertToBoolean } from '@holmescorp/common';
import { CountdownTimer } from '../widgets/countdown-timer';
import css from '../css/mcquestion.m.css';
import { setQuestion } from '../support/state';
import MCQuestionBase from './mc-base';
let MCQuestionPretest = class MCQuestionPretest extends MCQuestionBase {
    onChange(value) {
        const { question, quizstore } = this.properties;
        question.distractororder.forEach((key) => {
            question.distractordata[key].chosen = false;
        });
        question.distractordata[+value].chosen = true;
        question.answer = value;
        setQuestion(quizstore)({ question });
        this.invalidate();
    }
    update_result() {
        const { question, updater } = this.properties;
        const { icode = {}, status, cursor, answer } = question;
        const data = {
            answer,
            icode: { ...icode, _answer: answer },
            starttime: question.starttime,
            stoptime: timesync.now().toJSON(),
            isseen: true,
            ismarked: false
        };
        const qrlocator = {
            status,
            cursor,
            qrid: '',
            quiz: ''
        };
        const result = { qrlocator, data };
        return updater([result]);
    }
    render_buttons(which) {
        const { messages: { finish: finishText = '', submit: submitText = '', show_pretest_timer = 'true', show_posttest_timer = 'true' } } = this.properties.localizedBundle;
        const { quizstore, quizkind, onNextQuestion, onFinish, theme } = this.properties;
        const { islast = false } = which;
        let showTimer = true;
        if (quizkind == 'pretest') {
            showTimer = convertToBoolean(show_pretest_timer);
        }
        else if (quizkind == 'posttest') {
            showTimer = convertToBoolean(show_posttest_timer);
        }
        const buttons = [
            islast
                ? v('div', { classes: [this.theme(css.oneaction), this.theme(css.primaryButton)] }, [
                    w(Button, {
                        key: 'finish',
                        onClick: async () => {
                            if (!this._inFinish) {
                                this._inFinish = true;
                                await this.update_result();
                                onFinish();
                            }
                        }
                    }, [finishText])
                ])
                : v('div', { classes: [this.theme(css.oneaction), this.theme(css.primaryButton)] }, [
                    w(Button, {
                        theme,
                        key: 'submit',
                        onClick: () => {
                            if (!this._inSubmit) {
                                this._inSubmit = true;
                                this.update_result().then(() => {
                                    onNextQuestion();
                                });
                            }
                        }
                    }, [submitText])
                ]),
            showTimer
                ? v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
                    v('div', { classes: [this.theme(css.timer)] }, [
                        w(CountdownTimer, { quizstore, countdown: '' })
                    ])
                ])
                : null
        ];
        return buttons;
    }
    render() {
        return this.render_question();
    }
};
MCQuestionPretest = __decorate([
    theme(css)
], MCQuestionPretest);
export { MCQuestionPretest };
export default MCQuestionPretest;
